import { useField } from "formik"
import { useCallback } from "react";

export const useAddRemoveCategory = () => {
    const [{ value: categories }, , { setValue: setCategories, setError }] =
        useField<any[]>("category_list");

    const safeCategories = categories ?? [];

    const isAlreadyAdded = useCallback(
        (category: any) => {
            return category?.id && safeCategories.some((c: any) => c.id === category.id);
        },
        [safeCategories]
    );

    const addCategories = useCallback(
        (toAdd: any[]) => {
            const filtered = toAdd.filter(
                (c) => !safeCategories.some((p) => p.id === c.id)
            );

            const updated = [
                ...safeCategories,
                ...filtered.map(({ id, name }) => ({ id, name }))
            ];

            setCategories(updated);
        },
        [safeCategories, setCategories]
    );

    const removeCategories = useCallback(
        (toRemove: { id: string }[]) => {
            const idsToRemove = toRemove.map((d) => d.id);

            const updated = safeCategories.filter(
                (c) => !idsToRemove.includes(c.id)
            );

            setCategories(updated);
            setError(undefined);
        },
        [safeCategories, setCategories, setError]
    );

    return {
        categories: safeCategories,
        isAlreadyAdded,
        addCategories,
        removeCategories
    };
};
